module.exports = __webpack_public_path__ + "static/img/5.2ce48b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/rongyao/5.png
// module id = ai9e
// module chunks = 0